export default "/images/skip-backward.svg?527367d6a87256547b3ec2f4de87e5fa";